<template>
  <q-layout view="lHh lpr lFf" v-if="isHydrated" :class="{
    'bg-fb':
      route.name === 'ProfilePage' ||
      route.name === 'ProfileSettingsPage' ||
      route.name === 'OrdersSubscriptionPage' ||
      route.name === 'VerifiedReviewerEditPage' ||
      // route.name === 'VerifiedReviewerPage' ||
      route.name === 'SubscriptionPage' ||
      route.name === 'ReviewProfilePage' ||
      route.name === 'ResultPage' ||
      route.name === 'BusinessProfilePage' ||
      route.name === 'SearchResultsPage' ||
      route.name === 'ReviewPage' ||
      route.name === 'AboutUsPage' ||
      route.name === 'PrivacyPage' ||
      route.name === 'TermsPage' ||
      route.name === 'wallet' ||
      route.name === 'wallet-withdraw' ||
      route.name === 'PaymentStatusPage'
  }">
    <!-- <Header /> -->
    <NewHeader v-if="!route.meta.hideHeader && route.name !== 'JoinUsPage'" />
    <q-page-container :class="{
      'q-pt-0':
        route.name === 'ProfileSettingsPage' ||
        route.name === 'OrdersSubscriptionPage' ||
        route.name === 'VerifiedReviewerEditPage' ||
        // route.name === 'VerifiedReviewerPage' ||
        route.name === 'SubscriptionPage' ||
        route.name === 'ReviewProfilePage' ||
        route.name === 'BusinessProfilePage'
    }">
      <q-page :style-fn="myTweak">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" :key="route.fullPath" />
          </transition>
        </router-view>
      </q-page>
    </q-page-container>
    <!-- <Footer /> -->
    <NewFooter v-if="!route.meta.hideFooter && route.name !== 'JoinUsPage'" />
    <WhatsappBtn />
  </q-layout>
</template>

<script setup lang="ts">
// import Header from '@/components/ui/HeaderComponent.vue';
// import Footer from '@/components/ui/FooterComponent.vue';
import NewHeader from '@/components/ui/NewHeaderComponent.vue';
import NewFooter from '@/components/ui/NewFooterComponent.vue';
import WhatsappBtn from '@/components/ui/WhatsappBtn.vue';
import { useHydration, useMeta, QLayout, QPageContainer, QPage } from 'quasar';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';



const { isHydrated } = useHydration();
const route = useRoute();
const authStore = useAuthStore();

const computedMetaTags = computed(() => route.meta)
useMeta(computedMetaTags.value!);


const myTweak = (offset: number) => {
  // "offset" is a Number (pixels) that refers to the total
  // height of header + footer that occupies on screen,
  // based on the QLayout "view" prop configuration

  // this is actually what the default style-fn does in Quasar
  return { minHeight: offset ? `calc(100vh - ${offset}px - 0px)` : '100vh' };
};
</script>
